module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": _vm._id,
      "width": _vm.svgWidth,
      "height": _vm.svgHeight
    }
  }, [_vm._l((_vm.minorTicks), function(tick) {
    return _c('line', {
      attrs: {
        "x1": tick.x1,
        "x2": tick.x2,
        "y1": tick.y1,
        "y2": tick.y2,
        "stroke": "#777",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.majorTicks), function(tick) {
    return _c('line', {
      attrs: {
        "x1": tick.x1,
        "x2": tick.x2,
        "y1": tick.y1,
        "y2": tick.y2,
        "stroke": "#777",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _vm._l((_vm.majorTicks), function(tick) {
    return (_vm.horizontal) ? _c('text', {
      attrs: {
        "x": tick.x1 + _vm.textOffset,
        "y": "15",
        "fill": "black",
        "font-size": "10"
      }
    }, [_vm._v(_vm._s(tick.value))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.majorTicks), function(tick) {
    return (_vm.vertical) ? _c('text', {
      attrs: {
        "y": tick.y1 + 12,
        "x": "5",
        "fill": "black",
        "font-size": "10"
      }
    }, [_vm._v(_vm._s(tick.value))]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da54c2dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ruler.vue
// module id = 428
// module chunks = 1